import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '@store';
import { selectVehicleType } from './vehicleConfigurationSelectors';
import { selectSnapshotVehicleType, selectVehicleUsageCode } from './order/snapshotSelectors';

// Vehicle Details
export const selectVehicleDetails = (state: RootState) => {
  return state.vehicleDetails?.vehicleDetails;
};

export const selectSelectedSerialNo = createSelector([selectVehicleDetails], (vehicleDetails) => {
  return vehicleDetails?.selectedSerialNo;
});

export const selectVehicleAvailabilityCode = (state: RootState) => {
  return state.vehicleDetails?.vehicleDetails?.vehicleAvailabilityCode;
};

export const selectVehicleChargeStatus = (state: RootState) => {
  return state.vehicleDetails?.vehicleDetails?.vehicleChargeStatus;
};

// Implied
export const selectCarType = createSelector(
  [selectVehicleUsageCode, selectSnapshotVehicleType, selectVehicleType],
  (usageCode, pimVehicleType, vehicleType) => {
    return usageCode ?? pimVehicleType ?? vehicleType;
  }
);
